import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

export interface StepperStep {
  label: string;
  completed: boolean;
}

@Component({
  selector: 'aura-stepper',
  imports: [CommonModule, MatIconModule, MatButtonModule],
  templateUrl: './stepper.component.html',
  styles: [
    `
      :host {
        display: block;
      }

      .step-item {
        transition: all 0.2s ease-in-out;
      }

      .step-item.active {
        background-color: var(--mauve-2);
        border-radius: 0.75rem;
      }

      .step-dot {
        transform: translateY(-50%);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      }

      .step-item.active .step-dot {
        transform: translateY(-50%) scale(1.2);
        box-shadow: 0 0 0 4px var(--primary-3);
      }

      .step-label {
        transition: color 0.2s ease;
      }

      .step-item:hover .step-label {
        color: var(--primary-9);
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StepperComponent {
  steps = input.required<StepperStep[]>();
  purpose = input<string | null>(null);
  currentStepIndex = input<number>(0);
  stepSelected = output<number>();

  onStepClick(index: number) {
    this.stepSelected.emit(index);
  }
}
